// Auth storage + endpoint calls.
//
// The token key is shared with the dashboard and with the offline-download
// button that server/index.js injects into lecture pages, so it must stay
// 'mylecture-token' in localStorage.

import { getJson, postJson } from './api.js';

export const OAUTH_PROXY = 'https://oauth.xiangenhu.info';
export const TOKEN_KEY = 'mylecture-token';
export const USER_KEY = 'mylecture-user';

function safeGet(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage disabled */
  }
}

function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* storage disabled */
  }
}

export function getToken() {
  return safeGet(TOKEN_KEY);
}

export function setToken(token) {
  safeSet(TOKEN_KEY, token);
  try {
    sessionStorage.setItem('mylecture-fresh-oauth', '1');
  } catch {
    /* storage disabled */
  }
}

export function getCachedUser() {
  const raw = safeGet(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function cacheUser(user) {
  safeSet(USER_KEY, JSON.stringify(user));
}

export function clearStoredAuth() {
  safeRemove(TOKEN_KEY);
  safeRemove(USER_KEY);
}

export function googleLoginUrl() {
  const redirectUri = window.location.origin + window.location.pathname;
  return `${OAUTH_PROXY}/auth/google/login?redirect_uri=${encodeURIComponent(redirectUri)}`;
}

// Strip ?token / ?error from the URL after an OAuth round-trip, and return the
// token if one came back. Leaving them in the address bar would re-apply on reload.
export function consumeOAuthCallback() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const error = params.get('error');
  if (token) {
    setToken(token);
  }
  if (error) {
    console.warn('OAuth login failed:', error);
  }
  if (token || error) {
    window.history.replaceState({}, '', window.location.origin + window.location.pathname);
  }
  return token || null;
}

export const login = (email, password) => postJson('/api/user/login', { email, password });
export const register = (body) => postJson('/api/user/register', body);
export const resendCode = (email) => postJson('/api/user/resend-code', { email });
export const verifyCode = (email, code) => postJson('/api/user/verify', { email, code });
export const forgotPassword = (email) => postJson('/api/user/forgot-password', { email });
export const resetPassword = (resetToken, newPassword) =>
  postJson('/api/user/reset-password', { resetToken, newPassword });
export const fetchUserInfo = (token) => getJson('/api/auth/userinfo', token);

export function logoutRequest(token) {
  if (!token) return Promise.resolve();
  return fetch('/api/auth/logout', {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  }).catch(() => {});
}
